<template>
  <div class="message-cmenu" 
    :class="{
      'right': message.me
    }"
  >
    <v-menu top v-model="menu" nudge-left="10" z-index="1001">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon small v-bind="attrs" v-on="on">
          <v-icon class="far fa-ellipsis-vertical grey--text" size="24"></v-icon>
        </v-btn>
      </template>

      <v-list dense>
        <v-list-item @click="deleteMessage(false)">
          <v-list-item-title>
            <v-icon class="fas fa-trash-can pr-2" size="15"></v-icon>
           <translate>Delete message for you</translate>
          </v-list-item-title>
        </v-list-item>
        <v-list-item v-if="message.me" @click="deleteMessage(true)">
          <v-list-item-title>
            <v-icon class="fas fa-trash-can pr-2" size="15"></v-icon>
            <translate>Delete message both sides</translate>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import ChatService from "@/services/ChatService";
export default {
  name: "ChatMenuMessage",
  props: {
    friendId: {type: Number, default: null},
    message: {type: Object, default: () => {}},
    messageRaw: {type: Array, default: () => []}
  },
  data() {
    return {
      menu: false
    };
  },
  methods: {
    closeMenu() {
      this.menu = false;
    },
    async deleteMessage(unSent = false) {
      let data = {
        blockId: this.message.blockId,
        time: this.message.time,
        unSent
      };
      const result = await ChatService.deleteMessage(data);
      if(result.error) return;
      const message = Object.assign([], this.messageRaw);
      message[MESSAGE_DELETE_INDEX] = unSent ? MESSAGE_DELETE_BOTH : MESSAGE_DELETE_ME
      this.$store.commit('chat/commitMessage', {
        friendId: this.friendId,
        messages: [Object.assign([], message)]
      })
      this.$emit('deleteMessage', message)
      if(unSent === true) {
        this.$store.state.toggle.ChatFixedBottom.sendData({
          type: 'deleteMessage',
          payload: {
            friendId: this.$store.state.auth.userId,
            messages: [message]
          }
        }, this.friendId)
      }
      this.$store.dispatch('chat/getFriends')
    }
  },
};
</script>
<style lang="scss">
.message-cmenu {
  position: absolute;
  left: 100%;
  top: 4px;
  margin-left: -10px;
  &.right {
    right: 100%;
    left: auto;
    margin-left: 0;
    margin-right: -10px;
  }
  &.friend {
    margin-left: -30px;
    top: 10px;
  }
}
</style>